import { clientsClaim } from 'workbox-core';
import { precacheAndRoute } from 'workbox-precaching';

import { setupAssetsCaching } from './services/service-worker-assets-caching';
import { setupRequestsCaching } from './services/service-worker-requests-caching';
import { setupStoreDeviceMessagesOnNetworkError } from './services/service-worker-store-device-messages-on-network-error';
import { setupFirebaseMessaging } from './services/service-worker-firebase-messaging';

if (typeof importScripts === 'function') {
    importScripts('https://storage.googleapis.com/workbox-cdn/releases/6.1.5/workbox-sw.js');
    importScripts('https://www.gstatic.com/firebasejs/10.1.0/firebase-app-compat.js');
    importScripts('https://www.gstatic.com/firebasejs/10.1.0/firebase-messaging-compat.js');
}

self.addEventListener('install', event => {
    // Force le service worker à devenir le nouveau service worker actif
    event.waitUntil(self.skipWaiting());
});

self.addEventListener('activate', event => {
    // Prend le contrôle immédiat de toutes les pages ouvertes
    event.waitUntil(clientsClaim());
});

self.addEventListener('message', event => {
    console.log('RECEIVED IN SW', event.data);
    if (event.data && event.data.action === 'RELOAD_CLIENT_SERVICEWORKER') {
        event.waitUntil(
            self.skipWaiting().then(() => {
                return clientsClaim();
            }).then(() => {
                event.ports[0].postMessage({ status: 'success', action: 'refresh', target: 'all' });
            }).catch(err => {
                event.ports[0].postMessage({ status: 'error', message: err });
            })
        );
    } else if (event.data && event.data.action === 'SHOW_UPDATE') {
        const port = event.ports[0];
        console.log('SHOW_UPDATE 1', port);
        console.log('SHOW_UPDATE 1', event.ports);
        caches.open('logged-in-cached-data').then(async (cache) => {
          const updateResponse = await cache.match('showUpdate');
          const updateAvailable = await updateResponse?.text() ?? 'false';
          console.log('SHOW_UPDATE 2', port);
          port.postMessage({ showUpdate: updateAvailable, action: 'SHOW_UPDATE' });
        })
    }
});

// Precache all of the assets generated by your build process.
// Their URLs are injected into the manifest variable below.
// This variable must be present somewhere in your service worker file,
// even if you decide not to use precaching. See https://cra.link/PWA
const manifest = self.__WB_MANIFEST;
console.log('MANIFEST', manifest);
precacheAndRoute(manifest);

setupAssetsCaching();

setupRequestsCaching();

setupStoreDeviceMessagesOnNetworkError();

setupFirebaseMessaging();

